import { useEffect } from 'react';
import { SkeletonDashboard } from './Skeleton';
import { startProgress, stopProgress } from './TopProgressBar';

export function PageLoader({ label = 'Loading…' }: { label?: string }) {
  // Drive the top progress bar while a lazy chunk is in flight.
  useEffect(() => {
    startProgress();
    return () => { stopProgress(); };
  }, []);
  return (
    <div role="status" aria-label={label} style={{ padding: '24px' }}>
      <SkeletonDashboard />
    </div>
  );
}

export default PageLoader;
